export default "__VITE_ASSET__Bqxcj560__"